import { SECTION_DESCRIPTIONS } from '@communities/content-management/utils/sectionDescriptions';
import { Text, Heading, Dialog } from '@soteria/design-system-ve';

import * as styles from './MoreInfoDialog.css';

interface ActionsMoreInfoDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ActionsMoreInfoDialog({ isOpen, onClose }: ActionsMoreInfoDialogProps) {
  return (
    <Dialog cancelAction={{ label: 'Close' }} isOpen={isOpen} size="xxxl" title={SECTION_DESCRIPTIONS.ACTIONS.title} onClose={onClose}>
      <div className={styles.dialogContent}>
        <Text>
          Actions define what happens when content violates your community guidelines. They're the automated responses that help maintain community standards
          without requiring constant manual intervention.
        </Text>

        <div className={styles.section}>
          <Heading level="h3">Key benefits:</Heading>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <Text>Automate moderation responses for consistent enforcement</Text>
            </li>
            <li className={styles.listItem}>
              <Text>Scale your moderation efforts efficiently</Text>
            </li>
            <li className={styles.listItem}>
              <Text>Provide clear consequences for policy violations</Text>
            </li>
          </ul>
        </div>

        <Text>
          Common actions include warnings, content removal, temporary restrictions, and permanent bans. Each action can be configured with specific triggers and
          escalation paths.
        </Text>
      </div>
    </Dialog>
  );
}
